import { hasFinalScore, isPastEvent, isPredictionOpen } from './gameSchedule';

// The games a squad page leads with, most recent first: the one in progress (else the latest
// final), then the next one up. Either half can be missing.
export function pickGameDayEvents(events) {
  const list = Array.isArray(events) ? events : [];
  let recent = list.find((e) => !hasFinalScore(e) && !isPredictionOpen(e) && !isPastEvent(e)) || null;
  if (!recent) {
    const past = list.filter((e) => isPastEvent(e) && hasFinalScore(e));
    recent = past.length ? past[past.length - 1] : null;
  }
  const next = list.find((e) => !isPastEvent(e) && e !== recent) || null;
  return [recent, next].filter(Boolean);
}
